import React from 'react';
import { CreatePage } from '@components/common';
import LocationForm from '@components/common/forms/LocationForm';

const LocationCreatePage = () => {
    return (
        <CreatePage
            modelName="locations"
            FormComponent={LocationForm}
        />
    );
};

export default LocationCreatePage;
